import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Alert from 'react-s-alert';
import styled from 'styled-components';

import { Button } from '../../components/Button';
import { Input } from '../../components/Input';

import { handleLogin } from '../../actions/users';
import { PRIMARY, GREY, WHITE, PRIMARY_LIGHT, SECONDARY, SECONDARY_DARK, SECONDARY_LIGHT } from '../../constants/colors';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(to right bottom, ${SECONDARY_DARK}, ${SECONDARY}, ${SECONDARY_LIGHT}, ${PRIMARY}, ${PRIMARY_LIGHT});
`;

const InnerWrapper = styled.div`
  width: 500px;
  height: 300px;
  padding: 20px;
  border: 1px solid ${GREY};
  border-radius: 3px;
  background-color: ${WHITE};
  text-align: left;

  > h1 {
    text-align: center;
  }

  > input {
    margin-bottom: 20px;
  }
`;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
    };
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidUpdate() {
    const { user } = this.props;
    if (user.error) {
      Alert.error(user.error, {timeout: 2000});
    }
  }

  handleUsernameChange(e) {
    this.setState({ username: e.target.value });
  }

  handlePasswordChange(e) {
    this.setState({ password: e.target.value });
  }

  handleSubmit() {
    const { username, password } = this.state;
    const { handleLogin } = this.props;

    if (username && password) {
      handleLogin(username, password);
    }
  }

  render() {
    const { username, password } = this.state;
    const { user } = this.props;

    if (user.isLogged) {
      return <Redirect to="/" />;
    }

    return (
      <Wrapper>
        <InnerWrapper>
          <h1>
            Login
          </h1>
          <Input
            onChange={this.handleUsernameChange}
            placeholder="Username"
            type="text"
            value={username}
          />
          <Input
            onChange={this.handlePasswordChange}
            placeholder="Password"
            type="password"
            value={password}
          />
          <br />
          <Button
            block
            onClick={this.handleSubmit}
          >
            LOGIN
          </Button>
        </InnerWrapper>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    handleLogin,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/index.js